import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';

@Component({
    selector: 'app-special-messages-pop-up-list',
    templateUrl: './special-messages-pop-up-list.component.html',
    styleUrls: ['./special-messages-pop-up-list.component.scss'],
    standalone: false
})
export class SpecialMessagesPopUpListComponent {
  @Output() onItemClicked = new EventEmitter<SpecialMessage>();
  @Input() messages: SpecialMessage[]
}
